import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.js';
import '@fa/ui/tokens.css';
import '@fa/ui/app.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Dado fiscal muda o tempo todo (nota entra na fila, e autorizada,
      // rejeitada). Meio minuto de cache mantem a tela viva sem martelar a API.
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        // Nao insistir em 4xx: o problema esta no pedido, nao na rede.
        const status = (error as { status?: number }).status ?? 0;
        return status >= 500 && failureCount < 2;
      },
    },
  },
});

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
